import Cookies from "@/lib/cookies";
import config from "@/lib/config";

/**
 * 表示した商品（SVOD,TVOD）をCookieに保存する
 *
 * @param {object} req - リクエスト
 * @param {object} res - レスポンス
 * @constructor
 */
class ViewingArticle {
  constructor(req, res) {
    this.req = req;
    this.res = res;
    this.cookies = new Cookies(req, res);
  }

  /**
   * Cookieに保存されたデータを取得
   * @return {Object} payload
   */
  get() {
    const payload = this.cookies.get(config.viewingArticleCookieName);
    if (payload) {
      return JSON.parse(Buffer.from(payload, "base64").toString());
    } else {
      return {};
    }
  }

  /**
   * Cookieにデータを保存
   *
   * 保存するデータの仕様
   * { "type": "svod", "id": 1 }
   * type: "svod" or  "tvod"
   * id: ID
   *
   * @param {Object} payload
   * @param {string} payload.type - svod or tvod
   * @param {number[]} payload.id - ID
   */
  set(payload) {
    this.cookies.set({
      name: config.viewingArticleCookieName,
      value: Buffer.from(JSON.stringify(payload)).toString("base64"),
      options: {
        domain: this.req.host,
        maxAge: 1800,
      },
    });
  }

  /**
   * Cookieを削除
   */
  delete() {
    this.cookies.remove([
      [config.viewingArticleCookieName, { domain: this.req.host }],
    ]);
  }
}
export default ViewingArticle;
